<template>
	<section class="margin-both-lg container margin-auto" :class="classes">
		<div class="inner">
			<div class="content-inner">
				<h2 class="module-title">
					<span>{{ data.title }}</span>
				</h2>
				<div class="description" v-if="data.description" v-html="data.description"></div>
				<ColorLink
					:outlined="isDarkMode"
					v-if="data.link && data.link.url"
					:icon="false"
					uppercase
					:link="data.link"
					color="black"
				/>
			</div>
			<div class="imager" v-if="data.image">
				<WpImage :image="data.image" size="large" class="side-image" cover background />
			</div>
		</div>
	</section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import ColorLink from '@/components/elements/ColorLink'
import { mapGetters } from 'vuex'

export default {
	name: 'presentation-links',
	props: ['data'],
	computed: {
		...mapGetters(['isDarkMode']),
		classes() {
			let classes = []
			if (this.data.image_side) classes.push('side-' + this.data.image_side)
			if (this.data.image) classes.push('has-image')
			else classes.push('no-image')

			return classes.join(' ')
		},
	},
	components: {
		WpImage,
		ColorLink,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-presentation_links {
	.module-title {
		margin-top: 0;
		margin-bottom: 25px;
		z-index: 5;
		@include mquery($tablet) {
			margin-bottom: 20px;
		}
	}
	.description {
		margin-top: 0;
		font-weight: 400;
		margin-bottom: 40px;
		@include fluid-type($smallResText, $wideResText, 16px, 20px);
		@include mquery($phone) {
			margin-bottom: 25px;
		}
	}
	.links {
		margin-top: 40px;
		margin-bottom: 0;
		padding: 0;
		margin-left: -12px;
		margin-right: -12px;
		margin-bottom: -12px;
		li {
			list-style: none;
			display: inline-block;
			margin-left: 12px;
			margin-right: 12px;
			margin-bottom: 12px;
		}
		@include mquery($phone) {
			margin-left: -6px;
			margin-right: -6px;
			margin-bottom: -6px;
			margin-top: 20px;
			li {
				margin-bottom: 6px;
				margin-left: 6px;
				margin-right: 6px;
			}
		}
	}
	.inner {
		background-color: var(--gray);

		.content-inner {
			padding: 50px;
			@include mquery($tablet) {
				padding: 25px;
			}
			@include mquery($phone) {
				max-width: 100%;
			}
		}
	}
	&.no-image {
		.content-inner {
			text-align: center;
		}
		.module-title {
		}
	}
	&.has-image {
		&.side-right {
			.imager {
				padding-left: 25px;
			}
			.content-inner {
				padding-right: 25px;
				@include mquery($phone) {
					order: 2;
				}
			}
			@include mquery($tablet) {
				.imager {
					padding-left: 12.5px;
				}
				.content-inner {
					padding-right: 12.5px;
				}
			}
			@include mquery($phone) {
				.imager {
					padding-left: 0px;
				}
				.content-inner {
					padding: 25px;
				}
			}
		}
		&.side-left {
			.imager {
				padding-right: 25px;
			}
			.content-inner {
				order: 2;
				padding-left: 25px;
			}
			@include mquery($tablet) {
				.imager {
					padding-right: 12.5px;
				}
				.content-inner {
					padding-left: 12.5px;
				}
			}
			@include mquery($tablet) {
				.imager {
					padding-right: 0px;
				}
				.content-inner {
					padding: 25px;
				}
			}
		}
		.wp-image-vue {
			height: 100%;
		}
		.wp-image-vue.background .image {
			padding-bottom: 45.25%;
			min-height: 100%;
			@include mquery($phone) {
				min-height: 200px;
			}
		}
		.inner {
			display: flex;
			@include mquery($phone) {
				flex-direction: column;
			}
			.content-inner {
				max-width: 50%;
				width: 100%;
				align-self: center;
				position: relative;
				z-index: 10;
				@include mquery($phone) {
					max-width: 100%;
				}
			}
			.imager {
				max-width: 50%;
				width: 100%;
				@include mquery($phone) {
					max-width: 100%;
				}
			}
		}
	}
}
</style>
